"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CircleTick2.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CircleTick = function CircleTick(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "circle-icon",
    viewBox: "0 0 198.5 198.5"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Circle Tick Icon"), _react2.default.createElement("path", {
    d: "M99.25,0A99.25,99.25,0,1,0,198.5,99.25,99.36,99.36,0,0,0,99.25,0Zm0,189.48a90.23,90.23,0,1,1,90.23-90.23A90.33,90.33,0,0,1,99.25,189.48Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M99.25,17.6a81.66,81.66,0,1,0,81.66,81.66A81.75,81.75,0,0,0,99.25,17.6Zm0,160.61a78.95,78.95,0,1,1,78.95-79A79,79,0,0,1,99.25,178.2Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M138.86,67.72L134.26,64a5.12,5.12,0,0,0-7.18.74L88.56,120.45v0l-11.12-13.7A5.15,5.15,0,0,0,70.2,106l-4.54,3.7a5.15,5.15,0,0,0-.74,7.22l19.37,23.8c1.58,1.94,5.89,2.15,8.38.93,0.1,0,1.66-.5,6.44-8.21L139.6,74.9A5.12,5.12,0,0,0,138.86,67.72Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: undefined
  }));
};
exports.default = CircleTick;